import { assessmentConstants } from "../constants/assessmentConstants"

const A_FETCHING_USER = "A_FETCHING_USER"
const A_FETCHING_USER_SUCCESS = "A_FETCHING_USER_SUCCESS"
const A_FETCHING_USER_ERROR = "A_FETCHING_USER_ERROR"
const A_FETCHING_USER_ASSESSMENT = "A_FETCHING_USER_ASSESSMENT"

const A_ASSESSMENT_INITIALIZE = "A_ASSESSMENT_INITIALIZE"
const A_ASSESSMENT_INITIALIZE_SUCCESS = "A_ASSESSMENT_INITIALIZE_SUCCESS"
const A_ASSESSMENT_INITIALIZE_ERROR = "A_ASSESSMENT_INITIALIZE_ERROR"
const A_SET_IN_TEST = "A_SET_IN_TEST"
const STUDENT_SET_IN_TEST = "STUDENT_SET_IN_TEST"
const A_FETCHING_ACTIVE_ITEM = "A_FETCHING_ACTIVE_ITEM"
const A_FETCHING_ACTIVE_ITEM_SUCCESS = "A_FETCHING_ACTIVE_ITEM_SUCCESS"
const A_FETCHING_ACTIVE_ITEM_ERROR = "A_FETCHING_ACTIVE_ITEM_ERROR"
const SET_COMPARE_ASSISMENT_DATA = "SET_COMPARE_ASSISMENT_DATA"

const A_SET_SELECTED_ANSWER = "A_SET_SELECTED_ANSWER"

const A_SET_USER_ASSESSMENT = "A_SET_USER_ASSESSMENT"

const A_SUBMITTING_SUBTEST = "A_SUBMITTING_SUBTEST"
const A_SUBMITTING_SUBTEST_SUCCESS = "A_SUBMITTING_SUBTEST_SUCCESS"
const A_SUBMITTING_SUBTEST_ERROR = "A_SUBMITTING_SUBTEST_ERROR"

const A_FETCHING_NODES = "A_FETCHING_NODES"
const A_FETCHING_NODES_SUCCESS = "A_FETCHING_NODES_SUCCESS"
const A_FETCHING_NODES_ERROR = "A_FETCHING_NODES_ERROR"

const A_SET_SUBTEST_REPORT = "A_SET_SUBTEST_REPORT"

const A_FETCHING_SUBTEST_REPORT = "A_FETCHING_SUBTEST_REPORT"
const A_FETCHING_SUBTEST_REPORT_SUCCESS = "A_FETCHING_SUBTEST_REPORT_SUCCESS"
const A_FETCHING_SUBTEST_REPORT_ERROR = "A_FETCHING_SUBTEST_REPORT_ERROR"

const A_FETCHING_ALL_ITEMS = "A_FETCHING_ALL_ITEMS"
const A_FETCHING_ALL_ITEMS_SUCCESS = "A_FETCHING_ALL_ITEMS_SUCCESS"
const A_FETCHING_ALL_ITEMS_ERROR = "A_FETCHING_ALL_ITEMS_ERROR"

const A_FETCHING_ALL_PASSAGES = "A_FETCHING_ALL_PASSAGES"
const A_FETCHING_ALL_PASSAGES_SUCCESS = "A_FETCHING_ALL_PASSAGES_SUCCESS"
const A_FETCHING_ALL_PASSAGES_ERROR = "A_FETCHING_ALL_PASSAGES_ERROR"

const A_FETCHING_COMPAREGROUP_UAS_SUCCESS =
  "A_FETCHING_COMPAREGROUP_UAS_SUCCESS"

const A_FETCHING_GROUP_UAS = "A_FETCHING_GROUP_UAS"
const A_FETCHING_GROUP_UAS_SUCCESS = "A_FETCHING_GROUP_UAS_SUCCESS"
const A_FETCHING_GROUP_UAS_ERROR = "A_FETCHING_GROUP_UAS_ERROR"

const A_UNLOAD_ASSESSMENT_PAGE = "A_UNLOAD_ASSESSMENT_PAGE"
const A_LOAD_ASSESSMENT_PAGE = "A_LOAD_ASSESSMENT_PAGE"

const A_FONT_MAGNIFY = "A_FONT_MAGNIFY"
const A_FONT_DEMAGNIFY = "A_FONT_DEMAGNIFY"

const A_LOAD_ASSESSMENT_TIMEREMAINING = "A_LOAD_ASSESSMENT_TIMEREMAINING"

const A_SELECT_GROUP_UA = "A_SELECT_GROUP_UA"
const A_SELECT_STUDENT_ID = "A_SELECT_STUDENT_ID"

const A_SET_GUA_FILTER = "A_SET_GUA_FILTER"

const CLEAR_USER_ASSESMENT = "CLEAR_USER_ASSESMENT"

const A_IS_REFRESHING = "A_IS_REFRESHING"
const A_REFRESHING_SUCCESS = "A_REFRESHING_SUCCESS"
const A_REFRESHING_ERROR = "A_REFRESHING_ERROR"

const SET_SWAP_STATUS = "SET_SWAP_STATUS"

const A_FETCHING_SCHOOL = "A_FETCHING_SCHOOL"
const A_FETCHING_SCHOOL_SUCCESS = "A_FETCHING_SCHOOL_SUCCESS"
const A_FETCHING_SCHOOL_ERROR = "A_FETCHING_SCHOOL_ERROR"
const UPDATE_TIME_REMAINING = "UPDATE_TIME_REMAINING"

export function setSwapStatus(status) {
  return {
    type: SET_SWAP_STATUS,
    value: status
  }
}

export function isRefreshing() {
  return {
    type: A_IS_REFRESHING
  }
}

export function refreshingSuccess() {
  return {
    type: A_REFRESHING_SUCCESS
  }
}

export function refreshingError(error) {
  return {
    type: A_REFRESHING_ERROR,
    error
  }
}

export function setGUAFilter(GUAFilter) {
  return {
    type: A_SET_GUA_FILTER,
    GUAFilter
  }
}

export function selectGroupUA(selectedGroupUA) {
  return {
    type: A_SELECT_GROUP_UA,
    selectedGroupUA
  }
}

export function selectStudent(selectedStudent) {
  return {
    type: A_SELECT_STUDENT_ID,
    selectedStudent
  }
}

export function fetchingGroupUAs() {
  return {
    type: A_FETCHING_GROUP_UAS
  }
}
export function loadAssessmentHeader() {
  return {
    type: A_LOAD_ASSESSMENT_PAGE
  }
}
export function unLoadAssessmentHeader() {
  return {
    type: A_UNLOAD_ASSESSMENT_PAGE
  }
}

export function fetchingGroupUAsSuccess(groupUAs) {
  return {
    type: A_FETCHING_GROUP_UAS_SUCCESS,
    groupUAs
  }
}

export function fetchingGroupUAsError(error) {
  return {
    type: A_FETCHING_GROUP_UAS_ERROR,
    error
  }
}

export function fetchingAllPassages() {
  return {
    type: A_FETCHING_ALL_PASSAGES
  }
}

export function fetchingAllPassagesSuccess(passages) {
  return {
    type: A_FETCHING_ALL_PASSAGES_SUCCESS,
    passages
  }
}

export function fetchingAllPassagesError(error) {
  return {
    type: A_FETCHING_ALL_PASSAGES_ERROR,
    error
  }
}

export function updateTimeRemaining(timeRemaining) {
  return {
    type: A_LOAD_ASSESSMENT_TIMEREMAINING,
    timeRemaining
  }
}

export function onFontMagnify() {
  return {
    type: A_FONT_MAGNIFY
  }
}

export function onFontdeMagnify() {
  return {
    type: A_FONT_DEMAGNIFY
  }
}

export function fetchingAllItems() {
  return {
    type: A_FETCHING_ALL_ITEMS
  }
}

export function fetchingAllItemsSuccess(items) {
  return {
    type: A_FETCHING_ALL_ITEMS_SUCCESS,
    items
  }
}

export function fetchingAllItemsError(error) {
  return {
    type: A_FETCHING_ALL_ITEMS_ERROR,
    error
  }
}

export function fetchingSubtestReport() {
  return {
    type: A_FETCHING_SUBTEST_REPORT
  }
}

export function fetchingSubtestReportSuccess(report) {
  return {
    type: A_FETCHING_SUBTEST_REPORT_SUCCESS,
    report
  }
}

export function fetchingSubtestReportError(error) {
  return {
    type: A_FETCHING_SUBTEST_REPORT_ERROR,
    error
  }
}

export function setSubtestReport(report) {
  return {
    type: A_SET_SUBTEST_REPORT,
    report
  }
}

export function fetchingNodes() {
  return {
    type: A_FETCHING_NODES
  }
}

export function fetchingNodesSuccess(nodes) {
  return {
    type: A_FETCHING_NODES_SUCCESS,
    nodes
  }
}

export function fetchingNodesError(error) {
  return {
    type: A_FETCHING_NODES_ERROR,
    error
  }
}

export function submittingSubtest() {
  return {
    type: A_SUBMITTING_SUBTEST
  }
}

export function submittingSubtestSuccess() {
  return {
    type: A_SUBMITTING_SUBTEST_SUCCESS
  }
}

export function submittingSubtestError(error) {
  return {
    type: A_SUBMITTING_SUBTEST_ERROR,
    error
  }
}

export function setUserAssessment(userAssessment) {
  if (!userAssessment) {
    localStorage.removeItem("userAssessment")
  }
  return {
    type: A_SET_USER_ASSESSMENT,
    userAssessment
  }
}

export function setSelectedAnswer(answer) {
  return {
    type: A_SET_SELECTED_ANSWER,
    answer
  }
}

export function fetchingActiveItem() {
  return {
    type: A_FETCHING_ACTIVE_ITEM
  }
}

export function fetchingActiveItemSuccess(activeItem) {
  return {
    type: A_FETCHING_ACTIVE_ITEM_SUCCESS,
    activeItem
  }
}

export function fetchingActiveItemError(error) {
  return {
    type: A_FETCHING_ACTIVE_ITEM_ERROR,
    error
  }
}

export function assessmentInitialize() {
  return {
    type: A_ASSESSMENT_INITIALIZE
  }
}

export function assessmentInitializeSuccess(userAssessment) {
  localStorage.setItem("userAssessment", JSON.stringify(userAssessment))
  return {
    type: A_ASSESSMENT_INITIALIZE_SUCCESS,
    userAssessment
  }
}

export function assessmentInitializeError(error) {
  console.log("error", error)
  return {
    type: A_ASSESSMENT_INITIALIZE_ERROR,
    error
  }
}

export function setInTest(inTestQ) {
  return {
    type: A_SET_IN_TEST,
    inTestQ
  }
}

export function StudentInTest(inTest) {
  return {
    type: STUDENT_SET_IN_TEST,
    inTest
  }
}

export function fetchingUser() {
  return {
    type: A_FETCHING_USER
  }
}

export function fetchingUserSuccess(user) {
  return {
    type: A_FETCHING_USER_SUCCESS,
    user: JSON.parse(JSON.stringify(user))
  }
}

export function fetchingUserError(error) {
  return {
    type: A_FETCHING_USER_ERROR,
    error
  }
}

export function fetchingUserAssessment() {
  return {
    type: A_FETCHING_USER_ASSESSMENT
  }
}

export default function clearUserAssesment() {
  return {
    type: CLEAR_USER_ASSESMENT
  }
}

export function fetchingCompareGroupUAsSuccess(comparegroupUAs) {
  return {
    type: A_FETCHING_COMPAREGROUP_UAS_SUCCESS,
    comparegroupUAs
  }
}

export function fetchingSchool() {
  return {
    type: A_FETCHING_SCHOOL
  }
}

export function fetchingSchoolSuccess(school) {
  return {
    type: A_FETCHING_SCHOOL_SUCCESS,
    school
  }
}

export function fetchingSchoolError(error) {
  return {
    type: A_FETCHING_SCHOOL_ERROR,
    error
  }
}

export function setCumpareAssessmentData(compareAssessmentData) {
  return {
    type: SET_COMPARE_ASSISMENT_DATA,
    value: compareAssessmentData
  }
}

// Added export for setFooterData which was missing
export function setFooterData(footerData) {
  return {
    type: "SET_FOOTER_DATA",
    payload: footerData
  }
}

// Update Time remaining after setting initial time in db for a test
export function updateRemainingTime(id, time) {
  return dispatch => {
    dispatch({
      type: UPDATE_TIME_REMAINING,
      payload: { id, time }
    })
  }
}

const initialState = {
  fetchingSchool: false,
  fetchingSchoolError: "",
  refreshingGUA: false,
  refreshingError: "",
  isFetchingUserAssessment: false,
  isFetchingSelectedGroupUaData: false,
  selectedGroupUaDataError: "",
  fetchingUserAssessmentError: "",
  userAssessment: null,
  userAssessments: {},
  isFetchingUser: false,
  fetchingUserError: "",
  user: null,
  assessmentInitializingError: {},
  isInitializing: false,
  isInitializingUAs: false,
  inTest: false,
  activeItem: null,
  isFetchingActiveItem: false,
  isFetchingActiveItemError: "",
  selectedAnswer: "",
  isSubmittingSubtest: false,
  isSubmittingSubtestError: "",
  isFetchingNodes: false,
  isFetchingNodesError: "",
  nodes: null,
  subtestReport: null,
  isFetchingSubtestReport: false,
  isFetchingSubtestReportError: "",
  isFetchingAllItems: false,
  isFetchingAllItemsError: "",
  items: {},
  isFetchingAllPassages: false,
  isFetchingAllPassagesError: "",
  passages: {},
  isFetchingGroupUAs: false,
  groupUAs: {},
  isFetchingGroupUAsError: "",
  selectedGroupUA: null,
  selectedStudent: null,
  GUAFilter: null,
  loadAssessmentHeader: false,
  timeRemaining: 0,
  fontValue: 14,
  answersByItems: {},
  allAnswersByItem: {},
  modalStatus: {},
  studentAllUAs: {},
  fetchingStudentUAs: false,
  isUpdateGUALoading: false,
  fetchingScoringStatus: false,
  subtestScoringStatus: {},
  subtestScoringStatusError: null,
  assessmentSets: null,
  compareAssessmentData: null,
  footerData: null
}

export function assessment(state = initialState, action) {
  switch (action.type) {
    case SET_COMPARE_ASSISMENT_DATA:
      return {
        ...state,
        compareAssessmentData: action.value
      }
    case A_FETCHING_SCHOOL:
      return {
        ...state,
        fetchingSchool: true
      }
    case A_FETCHING_SCHOOL_SUCCESS:
      return {
        ...state,
        school: action.school,
        fetchingSchool: false
      }
    case A_FETCHING_SCHOOL_ERROR:
      return {
        ...state,
        fetchingSchool: false,
        fetchingSchoolError: action.error
      }
    case A_IS_REFRESHING:
      return {
        ...state,
        refreshingGUA: true,
        refreshingError: ""
      }
    case A_REFRESHING_SUCCESS:
      return {
        ...state,
        refreshingGUA: false,
        refreshingError: ""
      }
    case A_REFRESHING_ERROR:
      return {
        ...state,
        refreshingGUA: false,
        refreshingError: action.error
      }
    case A_SET_GUA_FILTER:
      return {
        ...state,
        GUAFilter: action.GUAFilter
      }
    case A_SELECT_GROUP_UA:
      return {
        ...state,
        selectedGroupUA: action.selectedGroupUA,
        selectedStudent: null
      }
    case A_SELECT_STUDENT_ID:
      return {
        ...state,
        selectedStudent: action.selectedStudent
      }
    case A_LOAD_ASSESSMENT_PAGE:
      return { ...state, loadAssessmentHeader: true }
    case A_UNLOAD_ASSESSMENT_PAGE:
      return { ...state, loadAssessmentHeader: false }
    case A_FETCHING_GROUP_UAS:
      return {
        ...state,
        isFetchingGroupUAs: true
      }
    case A_FETCHING_GROUP_UAS_SUCCESS:
      return {
        ...state,
        groupUAs: action.groupUAs,
        isFetchingGroupUAs: false
      }
    case A_FETCHING_GROUP_UAS_ERROR:
      return {
        ...state,
        isFetchingGroupUAs: false,
        isFetchingGroupUAsError: action.error
      }
    case assessmentConstants.DD_REFRESH_GUA:
      return {
        ...state,
        ddRefreshingGUAs: true,
        isFetchingGroupUAs: true
      }
    case assessmentConstants.DD_REFRESH_GUA_SUCCESS:
      return {
        ...state,
        groupUAs: { ...state.groupUAs, ...action.groupUAs },
        isFetchingGroupUAs: false,
        isInitializing: false,
        ddRefreshingGUAs: false
      }
    case assessmentConstants.DD_REFRESH_GUA_ERROR:
      return {
        ...state,
        isFetchingGroupUAs: false,
        isFetchingGroupUAsError: action.error,
        isInitializing: false,
        ddRefreshingGUAs: false
      }
    case A_FETCHING_ALL_PASSAGES:
      return {
        ...state,
        isFetchingAllPassages: true,
        isFetchingAllPassagesError: ""
      }
    case A_FETCHING_ALL_PASSAGES_SUCCESS:
      return {
        ...state,
        isFetchingAllPassages: false,
        passages: { ...state.passages, ...action.passages }
      }
    case A_FETCHING_ALL_PASSAGES_ERROR:
      return {
        ...state,
        isFetchingAllPassages: false,
        isFetchingAllPassagesError: action.error
      }

    case A_FETCHING_COMPAREGROUP_UAS_SUCCESS:
      return {
        ...state,
        comparegroupUAs: action.value,
        isFetchingGroupUAs: false
      }
    case A_FETCHING_ALL_ITEMS:
      return {
        ...state,
        isFetchingAllItems: true,
        isFetchingAllItemsError: ""
      }
    case A_FETCHING_ALL_ITEMS_SUCCESS:
      return {
        ...state,
        isFetchingAllItems: false,
        items: { ...state.items, ...action.items }
      }
    case A_FETCHING_ALL_ITEMS_ERROR:
      return {
        ...state,
        isFetchingAllItems: false,
        isFetchingAllItemsError: action.error
      }
    case A_FETCHING_SUBTEST_REPORT:
      return {
        ...state,
        isFetchingSubtestReport: true
      }
    case A_LOAD_ASSESSMENT_TIMEREMAINING:
      return {
        ...state,
        timeRemaining: action.timeRemaining
      }
    case A_FETCHING_SUBTEST_REPORT_SUCCESS:
      return {
        ...state,
        isFetchingSubtestReport: false,
        subtestReport: action.report
      }
    case A_FETCHING_SUBTEST_REPORT_ERROR:
      return {
        ...state,
        isFetchingSubtestReport: false,
        isFetchingSubtestReportError: action.error
      }
    case A_SET_SUBTEST_REPORT:
      return {
        ...state,
        subtestReport: action.report
      }
    case A_FETCHING_NODES:
      return {
        ...state,
        isFetchingNodes: true
      }
    case A_FETCHING_NODES_SUCCESS:
      return {
        ...state,
        nodes: action.nodes,
        isFetchingNodes: false
      }
    case A_FETCHING_NODES_ERROR:
      return {
        ...state,
        isFetchingNodes: false,
        isFetchingNodesError: action.error
      }
    case A_SUBMITTING_SUBTEST:
      return {
        ...state,
        isSubmittingSubtest: true
      }
    case A_SUBMITTING_SUBTEST_SUCCESS:
      return {
        ...state,
        isSubmittingSubtest: false,
        inTest: false
      }
    case A_SUBMITTING_SUBTEST_ERROR:
      return {
        ...state,
        isSubmittingSubtest: false,
        isSubmittingSubtestError: action.error
      }
    case A_SET_USER_ASSESSMENT:
      return {
        ...state,
        isInitializing: false,
        userAssessment: action.userAssessment
      }
    case A_SET_SELECTED_ANSWER:
      return {
        ...state,
        selectedAnswer: action.answer
      }
    case A_FETCHING_ACTIVE_ITEM:
      return {
        ...state,
        isFetchingActiveItem: true
      }
    case A_FETCHING_ACTIVE_ITEM_SUCCESS:
      return {
        ...state,
        isFetchingActiveItem: false,
        activeItem: action.activeItem
      }
    case A_FETCHING_ACTIVE_ITEM_ERROR:
      return {
        ...state,
        isFetchingActiveItem: false,
        isFetchingActiveItemError: action.error
      }
    case A_FONT_MAGNIFY:
      return {
        ...state,
        fontValue: state.fontValue < 22 ? state.fontValue + 1 : state.fontValue
      }
    case A_FONT_DEMAGNIFY:
      return {
        ...state,
        fontValue: state.fontValue > 12 ? state.fontValue - 1 : state.fontValue
      }
    case A_ASSESSMENT_INITIALIZE:
      return {
        ...state,
        isInitializing: true,
        userAssessment: null,
        assessmentInitializingError: {}
      }
    case A_ASSESSMENT_INITIALIZE_SUCCESS:
      return {
        ...state,
        isInitializing: false,
        userAssessment: action.userAssessment,
        assessmentInitializingError: {}
      }
    case A_ASSESSMENT_INITIALIZE_ERROR:
      return {
        ...state,
        isInitializing: false,
        assessmentInitializingError: action.error,
        userAssessment: null
      }
    case assessmentConstants.A_USER_ASSESSMENTS_INITIALIZE:
      return {
        ...state,
        isInitializingUAs: true
      }
    case assessmentConstants.A_USER_ASSESSMENTS_INITIALIZE_SUCCESS:
      return {
        ...state,
        isInitializingUAs: false,
        userAssessments: {
          ...state.userAssessments,
          ...action.userAssessments
        }
      }
    case A_SET_IN_TEST:
      return {
        ...state,
        inTest: action.inTestQ
      }
    case STUDENT_SET_IN_TEST:
      return {
        ...state,
        StudentInTest: action.inTest
      }
    case A_FETCHING_USER:
      return {
        ...state,
        isFetchingUser: true
      }
    case A_FETCHING_USER_SUCCESS:
      return {
        ...state,
        isFetchingUser: false,
        user: action.user
      }
    case A_FETCHING_USER_ERROR:
      return {
        ...state,
        isFetchingUser: false,
        fetchingUserError: action.error
      }
    case A_FETCHING_USER_ASSESSMENT:
      return {
        ...state,
        isFetchingUserAssessment: true
      }
    case CLEAR_USER_ASSESMENT:
      return {
        ...state,
        userAssessment: null
      }

    case assessmentConstants.GET_ASSESSMENT_SETS:
      return {
        ...state,
        fetchAssessmentSets: true
      }
    case assessmentConstants.GET_ASSESSMENT_SETS_SUCCESS:
      return {
        ...state,
        fetchAssessmentSets: false,
        assessmentSets: action.assessmentSets
      }
    case assessmentConstants.GET_ASSESSMENT_SETS_FAILED:
      return {
        ...state,
        fetchAssessmentSets: false,
        assessmentSetsFailed: action.error
      }
    case assessmentConstants.A_FETCHING_ANSWERS:
      return {
        ...state,
        fetchSubTestAnswers: true
      }
    case assessmentConstants.A_FETCHING_ANSWERS_SUCCESS:
      return {
        ...state,
        fetchSubTestAnswers: false,
        answersByItems: {
          ...state.answersByItems,
          ...action.answers
        }
      }
    case assessmentConstants.A_FETCHING_ANSWERS_ERROR:
      return {
        ...state,
        fetchSubTestAnswers: false
      }

    case assessmentConstants.UPDATE_ANSWER_ITEM: {
      // console.info(
      //   {
      //     action,
      //     answersByItems: state.answersByItems,
      //     answersByItem: state.answersByItems[action.answersByItemId]
      //   },
      //   "Dispatch handler for UPDATE_ANSWER_ITEM"
      // )
      return {
        ...state,
        answersByItems: {
          ...(state.answersByItems ?? {}),
          [action.answersByItemId]: {
            ...(state.answersByItems?.[action.answersByItemId] ?? {}),
            [action.itemNumber]: action.response,
            responseVectors: {
              ...(state.answersByItems?.[action.answersByItemId]?.[
                "responseVectors"
              ] ?? {}),
              [action.itemNumber]: action.isCorrect
            }
          }
        }
      }
    }

    case assessmentConstants.FETCH_VIDEO_STATUS_REQUEST:
      return {
        ...state,
        fetchingUserModalStatus: true
      }
    case assessmentConstants.FETCH_VIDEO_STATUS_SUCCESS:
      return {
        ...state,
        fetchingUserModalStatus: false,
        modalStatus: {
          ...state.modalStatus,
          ...action.status
        }
      }
    case assessmentConstants.FETCH_VIDEO_STATUS_FAILURE:
      return {
        ...state,
        fetchingUserModalStatus: false,
        modalStatusError: action.err
      }

    case assessmentConstants.UPDATE_TEST_VIDEO_STATUS_REQUEST:
      return {
        ...state,
        updatingUserModalStatus: true
      }
    case assessmentConstants.UPDATE_TEST_VIDEO_STATUS_SUCCESS:
      return {
        ...state,
        updatingUserModalStatus: false,
        modalStatus: {
          ...state.modalStatus,
          ...action.status
        }
      }
    case assessmentConstants.UPDATE_TEST_VIDEO_STATUS_FAILURE:
      return {
        ...state,
        updatingUserModalStatus: false,
        modalStatusError: action.err
      }

    case assessmentConstants.FETCH_SELECTED_GROUPUA_DATA:
      return {
        ...state,
        isFetchingGroupUAs: true
      }
    case assessmentConstants.FETCH_SELECTED_GROUPUA_DATA_SUCCESS:
      return {
        ...state,
        groupUAs: { ...state.groupUAs, ...action.groupUAs },
        isFetchingGroupUAs: false
      }
    case assessmentConstants.FETCH_SELECTED_GROUPUA_DATA_ERROR:
      return {
        ...state,
        isFetchingGroupUAs: false
      }

    case "MULTIPLE_YEAR_GUAs":
      return {
        ...state,
        refreshingGUA: false,
        groupUAs: {
          ...state.groupUAs,
          ...action.groupUAs
        }
      }

    case assessmentConstants.FETCH_STUDENT_UAS_REQUEST:
      return {
        ...state,
        fetchingStudentUAs: true
      }
    case assessmentConstants.FETCH_STUDENT_UAS_SUCCESS:
      return {
        ...state,
        fetchingStudentUAs: false,
        studentAllUAs: {
          studentId: action.studentId,
          uAs: action.userAssessments
        }
      }
    case assessmentConstants.FETCH_STUDENT_UAS_FAILURE:
      return {
        ...state,
        fetchingStudentUAs: false,
        studentAllUAsError: action.error
      }
    case assessmentConstants.UPDATE_GUA_THRESHOLD_DATA:
      return {
        ...state,
        isUpdateGUALoading: true
      }
    case assessmentConstants.UPDATE_GUA_THRESHOLD_DATA_SUCCESS:
      return {
        ...state,
        isUpdateGUALoading: false
      }
    case assessmentConstants.UPDATE_GUA_THRESHOLD_DATA_ERROR:
      return {
        ...state,
        isUpdateGUALoading: false
      }

    case "RESET_SUBTEST":
      return {
        ...state,
        resetSubtestId: action.subtestId,
        resetSubtestErr: ""
      }

    case "RESET_SUBTEST_COMPLETE":
      return {
        ...state,
        resetSubtestId: "",
        userAssessment: action.userAssessment,
        resetSubtestErr: ""
      }

    case "RESET_SUBTEST_FAILED":
      return {
        ...state,
        resetSubtestId: "",
        resetSubtestErr: action.err
      }

    case "RESET_SUBTEST_FAILED_CLEAR":
      return {
        ...state,
        resetSubtestErr: ""
      }
    case UPDATE_TIME_REMAINING:
      const {
        payload: { id, time }
      } = action
      return {
        ...state,
        userAssessment: {
          ...state.userAssessment,
          timeRemaining: {
            ...state.userAssessment.timeRemaining,
            [id]: time
          }
        }
      }

    case assessmentConstants.A_ASSESSMENT_SCORING_STATUS:
      return {
        ...state,
        fetchingScoringStatus: true
      }

    case assessmentConstants.A_ASSESSMENT_SCORING_STATUS_SUCCESS:
      return {
        ...state,
        subtestScoringStatus: action.subtestScoringStatus,
        fetchingScoringStatus: false
      }

    case assessmentConstants.A_ASSESSMENT_SCORING_STATUS_ERROR:
      return {
        ...state,
        subtestScoringStatusError: action.error,
        fetchingScoringStatus: false
      }

    // key on fetch selected guas
    case assessmentConstants.FETCH_SELECTED_GROUPUA_DATA:
      return {
        ...state,
        isFetchingSelectedGroupUaData: true,
        selectedGroupUaDataError: ""
      }

    case assessmentConstants.FETCH_SELECTED_GROUPUA_DATA_SUCCESS:
      return {
        ...state,
        isFetchingSelectedGroupUaData: false,
        selectedGroupUaDataError: ""
      }

    case assessmentConstants.FETCH_SELECTED_GROUPUA_DATA_ERROR:
      return {
        ...state,
        isFetchingSelectedGroupUaData: false,
        selectedGroupUaDataError: action.error
      }

    case "SET_FOOTER_DATA":
      return {
        ...state,
        footerData: action.payload
      }

    default:
      return state
  }
}
